import React from 'react';
import { browserHistory } from 'react-router';
import './AlarmSounding.css';

import {
  inject,
  observer
} from 'mobx-react';

import Alert from '../../components/Alert/Alert.js';
import Button from '../../components/Button/Button.js';
import Clock from '../../components/Clock/Clock.js';

import {
  addMinutesChangeEvent,
  removeMinutesChangeEvent
} from '../../utils/datetime';
import animation from '../../utils/animation';
import { setBackground } from '../../utils/style.js';

class AlarmSounding extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: new Date()
    }

    this.audio = new Audio(process.env.PUBLIC_URL + '/audio/chimes.mp3');
    this.audio.loop = true;
    this.audio.volume = 0;
  }

  render() {
    return (
      <div className='alarm-sounding'>
        {this.props.alarmStore.next ?
          <div className='alarm-sounding__next'>
            <Alert corner='tr'>
              Next Alarm: {this.props.alarmStore.next.timeUntil}
            </Alert>
          </div>
        : null}

        <div className='alarm-sounding__clock'>
          <Clock date={this.state.date} />
        </div>

        <div className='alarm-sounding__btns'>
          <Button
            type='blend'
            size='lg'
            textColor='white'
            onClick={() => {
              this.state.alarm.snooze();
              browserHistory.replace('/');
            }}>
            Snooze
          </Button>
          <Button
            type='blend'
            size='lg'
            textColor='white'
            onClick={() => {
              this.props.settingsStore.disableSleepMode();
              browserHistory.replace('/');
            }}>
            Dismiss
          </Button>
        </div>
      </div>
    );
  }

  componentWillMount() {
    setBackground('yellow');
  }

  componentDidMount() {
    this.props.alarmStore.get(parseInt(this.props.params.id, 10), alarm => {
      this.setState({
        alarm: alarm
      })
    });

    addMinutesChangeEvent('alarm_sounding_clock', date => {
      this.setState({
        date: date
      })
    });

    this.startAudio();
  }

  componentWillUnmount() {
    removeMinutesChangeEvent('alarm_sounding_clock');
    this.audio.pause();
  }

  startAudio() {
    this.audio.addEventListener('loadeddata', () => {
      this.audio.play()
      animation(0, 1, (vol) => {
        this.audio.volume = vol;
      }, {
        duration: 60000
      })
    });
  }

};

export default inject('alarmStore', 'settingsStore')(observer(AlarmSounding));



// WEBPACK FOOTER //
// ./src/views/AlarmSounding/index.js